import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  TaglineTitle,
} from "./styles";

let query = `
    feedbackTitle
    feedbackSection {
      title
      description
      image {
        data {
          attributes {
            url
          }
        }
      }
    }
  `;

export default function HXFeedback() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { feedbackTitle, feedbackSection } = response || {};
    setSolutions(feedbackTitle);
    setSolutionsCard(feedbackSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineTitle
        dangerouslySetInnerHTML={{ __html: solutions }}
      ></TaglineTitle>

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => (
          <CardListContainer
            key={cardIndex}
            cardNumber={cardIndex}
            backgroundImage={`https://assets.hiredly.com/cms/11062b_916e6674cff64736acbf49ae13678e99mv2_jpeg_de60596f18.png`}
          >
            <CardText
              type={"desc"}
              cardNumber={cardIndex}
              dangerouslySetInnerHTML={{ __html: cards?.description }}
            ></CardText>

            <CardTextContainer>
              <CardImage src={cards?.image?.data?.attributes?.url} />
              <CardText
                type={"title"}
                cardNumber={cardIndex}
                dangerouslySetInnerHTML={{ __html: cards?.title }}
              ></CardText>
            </CardTextContainer>
          </CardListContainer>
        ))}
      </CardContainer>
    </GridContainerStyled>
  );
}
